import React, { useState, useEffect, useContext } from "react"
import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Typography
} from '@material-ui/core';

import { GLB_URL_APIS } from '../utils/APIS'


const Terms_FR = () => {

  return (
    <>
      <Helmet>
        <title>TheLab</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <iframe
          title="Terms 2023 FR"
          style={{
            width : '100%',
            height:'calc(100vh)',
            marginBottom : '0px',
          }}
          src={GLB_URL_APIS+"/docs/terms_2023_FR.pdf"}
          >
        </iframe>
      </Box>
    </>
  )
};

export default Terms_FR;
